import type { FetchVatDefinitionListParams } from 'Services/ProductManagement/Features/VATDefinition/types'
import { useGetVatDefinitionsQuery } from 'Services/ProductManagement/Features/VATDefinition/vatDefinitionApi'
import { All_VAT_DEFINITIONS_COUNT_PER_REQUEST, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_VAT_DEFINITION_PARAMETER_KEY = 'selectedVatDefinition'

export function useVATDefinitionsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQueryParams, setSearchQueryParams] = useState<FetchVatDefinitionListParams>({
    count: All_VAT_DEFINITIONS_COUNT_PER_REQUEST,
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'title',
    start_index: searchParams.get('start_index') ?? undefined,
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC
  })

  const { data: vatDefinitions = [], isFetching } = useGetVatDefinitionsQuery(searchQueryParams)

  const selectedVatDefinitionQueryParam =
    searchParams.get(SELECTED_VAT_DEFINITION_PARAMETER_KEY) ?? undefined
  const [selectedVatDefinitionId, setSelectedVatDefinitionId] = useState(
    selectedVatDefinitionQueryParam
  )

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedVatDefinitionId &&
      searchParams.set(SELECTED_VAT_DEFINITION_PARAMETER_KEY, selectedVatDefinitionId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  useEffect(() => {
    if (selectedVatDefinitionId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_VAT_DEFINITION_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedVatDefinitionId])

  return {
    vatDefinitions,
    isFetching,
    total_results: vatDefinitions.length,
    searchQueryParams,
    setSearchQueryParams,
    selectedVatDefinitionId,
    setSelectedVatDefinitionId
  }
}

export default useVATDefinitionsWithParams
